var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$tvaMq !== 'mobile' && _vm.$tvaMq !== 'tablet')?_c('SourcePageDesktop'):_c('SourcePageMobile')}
var staticRenderFns = []

export { render, staticRenderFns }